module.exports = __webpack_public_path__ + "static/media/FiberousVeryThinRoot4.73d61212.png";